import storageService from "@/Components/helpers/storageService";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { Environment } from "../ApiCollection/envApi";

interface Project {
  _id: string;
  workspaceId: string;
  title: string;
  description: string;
  [key: string]: any;
}
interface GlobalDataState {
  teams: any[];
  refetchTeam: boolean;
  refetchProfile: boolean;
  activeTeam: any;
  projectList: any[];
  refetchProject: boolean;
  activeProject: any;
  envList: any[];
  activeEnvironment: any;
  currentSidebarSelection: string;
  refetchEnv: boolean;
  refetchEnvChild: boolean;
  globalEnv: any;
  environmentVariables: any;
  collectionEnv: any;
  currentUser: any;
  isLogin: boolean;
  selectedLanguage: string;
  currentTheme: any;
  roleCodeDetails: any;
  stickySelected: any;
  userPreferences: {
    menuItems: Record<string, boolean>;
  };
  loadingStates: {
    team: boolean;
    project: boolean;
    environment: boolean;
    envVariables: boolean;
  };
  alerts: {
    _id: string;
    type: "success" | "error" | "warning" | "info";
    message: string;
    link: string;
    linkText: string;
    isCritical: boolean;
    title?: string;
    show: boolean;
  }[];
  companyDetails: any;
  shouldShowRequestIcon: boolean;
  dateFormat: string;
  recordsPerPage: number;
  userProfile: {
    [key: string]: any;
    userPreferences: Record<string, boolean>;
    activeItems: {
      activeTeam: string;
      activeProject: string;
      activeEnv: string;
    };
  };
  language: string;
  shouldCallAgent: boolean;
  reactFlow: any;
}

export const initialState: GlobalDataState = {
  teams: [],
  refetchTeam: false,
  refetchProfile: false,
  activeTeam: null,
  projectList: [],
  refetchProject: false,
  activeProject: null,
  envList: [],
  activeEnvironment: null,
  currentSidebarSelection: "",
  refetchEnv: false,
  refetchEnvChild: false,
  globalEnv: {},
  environmentVariables: {},
  collectionEnv: {},
  currentUser: null,
  isLogin: false,
  selectedLanguage: storageService.get("language") || "en",
  currentTheme: "Purple",
  roleCodeDetails: null,
  stickySelected: null,
  userPreferences: {
    menuItems: JSON.parse("{}"),
  },
  loadingStates: {
    team: false,
    project: false,
    environment: false,
    envVariables: false,
  },
  alerts: [],
  companyDetails: null,
  shouldShowRequestIcon: false,
  dateFormat: "DD/MM/YY",
  recordsPerPage: 10,
  userProfile: {
    userPreferences: {},
    activeItems: {
      activeTeam: "",
      activeProject: "",
      activeEnv: "",
    },
  },
  language: "",
  shouldCallAgent: false,
  reactFlow: null,
};

const globalDataSlice = createSlice({
  name: "globalParentData",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setIsLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setState: (_state, action) => {
      return action.payload;
    },
    setTeams: (state, action) => {
      state.teams = action.payload;
    },
    setActiveTeam: (state, action) => {
      state.activeTeam = action.payload;
      localStorage.setItem("activeTeam", JSON.stringify(action.payload));
      // if (action.payload?._id && state.teamProjectMap[action.payload._id]) {
      //   state.activeProject = state.teamProjectMap[action.payload._id];
      //   storageService.set(
      //     "activeProject",
      //     JSON.stringify(state.teamProjectMap[action.payload._id])
      //   );
      // }
    },
    setProjectList: (state, action) => {
      state.projectList = action.payload;
    },
    setActiveProject: (state, action) => {
      state.activeProject = action.payload;
      localStorage.setItem("activeProject", JSON.stringify(action.payload));
      // if (state.activeTeam?._id && action.payload) {
      //   state.teamProjectMap[state.activeTeam._id] = action.payload;
      // }
    },
    setEnvList: (state, action) => {
      state.envList = action.payload;
    },
    setActiveEnvironment: (state, action) => {
      state.activeEnvironment = action.payload;
      // localStorage.setItem("activeEnvironment", JSON.stringify(action.payload));
    },
    setRefetchEnv: (state, action) => {
      state.refetchEnv = action.payload;
    },
    updateGlobalEnv: (state, action) => {
      state.globalEnv = action.payload;
    },
    setEnvironmentVariables: (state, action: PayloadAction<any>) => {
      state.environmentVariables = action.payload;
    },
    updateCollectionEnv(state, action: PayloadAction<any>) {
      state.collectionEnv = action.payload;
    },
    setSelectedLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
      storageService.set("language", action.payload);
    },
    setCurrentTheme: (state, action) => {
      state.currentTheme = action.payload;
    },
    setRoleCodeDetails: (state, action) => {
      state.roleCodeDetails = action.payload;
      storageService.set("roleCodeDetails", JSON.stringify(action.payload));
    },
    setSelectedSticky: (state, action) => {
      state.stickySelected = action.payload;
    },
    setUserMenuPreferences: (
      state,
      action: PayloadAction<Record<string, boolean>>
    ) => {
      if (!state.userPreferences) {
        const newObj = {
          menuItems: {},
        };
        state.userPreferences = newObj;
      }
      state.userPreferences.menuItems = action.payload;
      storageService.set("userMenuPreferences", JSON.stringify(action.payload));
    },
    toggleMenuItemPreference: (state, action: PayloadAction<string>) => {
      const menuItemId = action.payload;
      state.userPreferences.menuItems[menuItemId] =
        !state.userPreferences.menuItems[menuItemId];
      storageService.set(
        "userMenuPreferences",
        JSON.stringify(state.userPreferences.menuItems)
      );
    },
    setLoadingState: (
      state,
      action: PayloadAction<{
        key: keyof GlobalDataState["loadingStates"];
        value: boolean;
      }>
    ) => {
      state.loadingStates[action.payload.key] = action.payload.value;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    resetLoadingStates: (state) => {
      state.loadingStates = initialState.loadingStates;
    },
    setRefetchTeam: (state, action) => {
      state.refetchTeam = action.payload;
    },
    setRefetchProfile: (state, action) => {
      state.refetchProfile = action.payload;
    },
    setRefetchProject: (state, action) => {
      state.refetchProject = action.payload;
    },
    setAlerts: (state, action) => {
      state.alerts = action.payload;
    },
    setCompanyDetails: (state, action) => {
      state.companyDetails = action.payload;
    },
    setShouldShowRequestIcons: (state, action) => {
      state.shouldShowRequestIcon = action.payload;
    },
    setDateFormat: (state, action) => {
      state.dateFormat = action.payload;
    },
    setRecordsPerPage: (state, action) => {
      state.recordsPerPage = action.payload;
    },
    setRefetchEnvChild: (state, action) => {
      state.refetchEnvChild = action.payload;
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
    setTeamActiveProject(state, action) {
      state.activeProject = action.payload;
    },
    setTeamProjectList(state, action: PayloadAction<{ projects: Project[] }>) {
      state.projectList = action.payload.projects;
    },
    setShouldCallAgent(state, action: PayloadAction<{ shouldCallAgent: boolean }>) {
			const { shouldCallAgent } = action.payload;
			state.shouldCallAgent = shouldCallAgent;
		},
    setReactFlow(state, action: PayloadAction<{ reactFlow: any }>) {
      state.reactFlow = action.payload.reactFlow;
    },
  },
});

export const {
  setCurrentUser,
  setIsLogin,
  setState,
  setTeams,
  setActiveTeam,
  setRefetchProfile,
  setProjectList,
  setActiveProject,
  setEnvList,
  setActiveEnvironment,
  setRefetchEnv,
  setRefetchEnvChild,
  updateGlobalEnv,
  setEnvironmentVariables,
  updateCollectionEnv,
  setSelectedLanguage,
  setCurrentTheme,
  setRoleCodeDetails,
  setSelectedSticky,
  setLoadingState,
  resetLoadingStates,
  setRefetchTeam,
  setRefetchProject,
  setUserMenuPreferences,
  toggleMenuItemPreference,
  setAlerts,
  setCompanyDetails,
  setShouldShowRequestIcons,
  setDateFormat,
  setRecordsPerPage,
  setUserProfile,
  setLanguage,
  setTeamActiveProject,
  setTeamProjectList,
  setShouldCallAgent,
  setReactFlow,
} = globalDataSlice.actions;

export default globalDataSlice.reducer;
